import { useEffect, useRef, useState } from "react";

/** Revela o elemento (dispara a animação de entrada) só quando ele passa a
 * interceptar o viewport — cards acima da dobra revelam quase que
 * imediatamente (montagem inicial), os demais entram conforme a página é
 * rolada. Dispara uma única vez por elemento. */
export function useRevealOnScroll() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          obs.disconnect();
        }
      },
      { threshold: 0, rootMargin: "0px 0px 120px 0px" }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return { ref, visible };
}
